<!-- GridCanvas.vue -->
<template>
  <canvas ref="gridCanvas" width="400" height="400"></canvas>
</template>

<script>
export default {
  mounted() {
    this.drawGrid();
  },
  methods: {
    drawGrid() {
      const canvas = this.$refs.gridCanvas;
      const ctx = canvas.getContext('2d');
      const squareSize = 20;
      const rows = canvas.height / squareSize;
      const columns = canvas.width / squareSize;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < columns; col++) {
          const x = col * squareSize;
          const y = row * squareSize;

          ctx.beginPath();
          ctx.rect(x, y, squareSize, squareSize);
          ctx.stroke();
          ctx.closePath();
        }
      }
    },
  },
};
</script>

<style>
canvas {
  border: 1px solid #000;
}
</style>
